import { render, staticRenderFns } from "./EditDepositRuleLoader.vue?vue&type=template&id=653932d6"
import script from "./EditDepositRuleLoader.vue?vue&type=script&lang=ts"
export * from "./EditDepositRuleLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports